import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-formly-wrapper-checkbox-group',
  templateUrl: './formly-wrapper-checkbox-group.component.html',
  styleUrls: ['./formly-wrapper-checkbox-group.component.scss'],
  imports: [TranslateModule],
})
export class FormlyWrapperCheckboxGroupComponent extends FieldWrapper {}
